import React from 'react'
import './SampleEx';
import '../CSS/Sample.css'


const Sample = () => {
  return (
    <div id="container"></div>
  )
}

export default Sample